import {type Theme} from '@mui/material';

export const getTokens = (theme: Theme): string => /* scss */`
    --header-bar-height: ${theme.tokens.FuelSpacing12};
    --header-append-height: ${theme.tokens.FuelSpacing8};

    --header-height-desktop: var(--header-bar-height);
    --header-height-mobile: calc(var(--header-bar-height) + var(--header-append-height));
`;
